<template>
  <div id="app" style="height: 100%;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    const processMessage = async event => {
      if (event.origin === process.env.VUE_APP_HOSTNAME && event.data.authQueryString !== undefined) {
        if (event.data.authQueryString.error && event.data.authQueryString.error === 'access_denied') {
          return this.$buefy.toast.open({
            message: 'Sorry your access is denied. Please contact our customer care for assistance.',
            type: 'is-dark',
            pauseOnHover: true,
            position: 'is-bottom',
            duration: 5000
          })
        }
        const auth_code = event.data.authQueryString.code
        if (!auth_code) {
          localStorage.removeItem('verifier')
          localStorage.removeItem('token')
          return this.$router.push({ name: 'login' })
        }
        const loadingComponent = this.$buefy.loading.open()
        try {
          const token = await this.$store.dispatch('auth/getToken', auth_code)
          await this.$store.dispatch('auth/initiateSession', { token })
            .then(resp => {
              // Initiate session monitoring interval
              setInterval(async () => {
                let probeResult = await this.$store.dispatch('auth/probeSessioMonitoring', 'timer')
                if (!probeResult && !this.$store.state.auth.promptSessionAlert && this.$store.getters['auth/isAuthenticated']) {
                  this.$store.commit('auth/update_has_prompt_alert', true)
                  this.$buefy.dialog.alert({
                    title: 'Login Session Expiring Soon',
                    message: `You are 5 minutes away from the expiry of your login session. Please save your changes before the session ends. Alternatively, you can login again to reset.`,
                    confirmText: 'OK',
                    type: 'is-warning',
                    hasIcon: true,
                    icon: 'alert-circle-outline'
                  })
                }
              }, 1000);

              // Initiate datadog session monitoring
              this.$datadogRum.setUser({
                id: this.$store.state.user.uuid,
                email: this.$store.state.user.email
              })
              
              this.$router.push({ name: 'consultant-homepage' })
              return loadingComponent.close()
            })
            .catch(err => {
              if (err === 'agent_inactive') {
                alert('Sorry, this agent account is no longer active. Please contact sales support if you require any further assistance.')
                this.$store.dispatch('auth/logout')
                return loadingComponent.close()
              }
              if (err === 'no_agent_mapping') {
                this.$store.dispatch('auth/logout')
                // this.$router.push({ name: 'account-linking' })
                return loadingComponent.close()
              }
              throw err
            })
        } catch (err) {
          console.error(err)
          this.$store.dispatch('auth/logout')
          return loadingComponent.close()
        }
      }
    }
    // Add listener to receive message from popup
    window.addEventListener('message', processMessage, false)
  },
  created() {
    this.$store.dispatch('fetch_assets');
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Open Sans', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
